export const permissionsKeys = {
  adminVersion: 'admin-version',
  adminVersionFind: 'admin-version.page-version.find',
  adminVersionSelect: 'admin-version.page-version.select',
  adminVersionUpdateActive: 'admin-version.active.page-version.update',
  adminVersionUpdateDraft: 'admin-version.draft.page-version.update',
  adminVersionPreview: 'admin-version.page-version.preview',
  adminVersionRemove: 'admin-version.page-version.remove',
} as const;
